import { useRef } from 'react';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import { useSwipe } from '@/hooks/useSwipe';
import { useChat } from '@/hooks/useChat';
import IconClose from '@scramble/design-system/icons/x-close.svg';
import s from './index.module.scss';

export const ModalSwipeLayout = ({ children, showClose, onClose }) => {
  const ref = useRef(null);

  useSwipe(ref, () => onClose(), { sensitivity: 150, axis: 'vertical' });
  useChat(false);

  return createPortal(
    <div
      className={s.wrapper}
      data-role="modal-wrapper"
      onClick={e => e.stopPropagation()}
    >
      <div
        className={s.backdrop}
        onClick={onClose}
        data-role="modal-backdrop"
      />
      <div
        className={classnames(s.content, showClose && s.content_with_close)}
        ref={ref}
        data-role="modal-content"
      >
        <div className={s.inner}>
          <button type="button" className={s.btn_swipe} onClick={onClose} />
          {children}
        </div>

        {showClose && (
          <div className={s.btn_close} onClick={onClose}>
            <img
              src={IconClose}
              alt="close"
              width={20}
              height={20}
              data-role="modal-close-x"
            />
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};
